import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FiCheckCircle, FiMessageCircle } from "react-icons/fi";
import { useBusiness } from "../../../Common/Hooks/useBusiness";
import { CaseDetailsWrapper, CaseDetailsContent } from "../../DueDiligence/CaseDetails/Styles";
import styled from "styled-components";

const SuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 4rem 2rem;
  text-align: center;
`;

const SuccessCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 600px;
  width: 100%;
`;

const IconContainer = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;
  background-color: #DCFCE7;
  color: #16A34A;

  svg {
    width: 40px;
    height: 40px;
  }
`;

const Title = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  color: #111827;
  margin: 0 0 1rem 0;
  letter-spacing: -0.025em;
`;

const Message = styled.p`
  font-size: 1.125rem;
  color: #6B7280;
  line-height: 1.6;
  margin: 0 0 2.5rem 0;
  max-width: 480px;
`;

const PrimaryButton = styled.button`
  background-color: #000000;
  color: #FFFFFF;
  border: none;
  padding: 1rem 2rem;
  border-radius: 0.5rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);

  &:hover {
    background-color: #1a1a1a;
    transform: translateY(-1px);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

const SecondaryButton = styled.button`
  background-color: transparent;
  color: #6B7280;
  border: none;
  padding: 0.75rem 1.5rem;
  margin-top: 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: color 0.2s;

  &:hover {
    color: #111827;
  }
`;

export const SuccessPayment = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { resyncBusiness } = useBusiness();

  useEffect(() => {
    setTimeout(() => {
      resyncBusiness();
    }, 1000);
  }, [resyncBusiness]);

  return (
    <CaseDetailsWrapper>
      <CaseDetailsContent style={{ minHeight: '600px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <SuccessContainer>
          <SuccessCard>
            <IconContainer>
              <FiCheckCircle />
            </IconContainer>
            <Title>{t("common.auxiliar.successPayment.title")}</Title>
            <Message>
              {t("common.auxiliar.successPayment.message")}
            </Message>
            <PrimaryButton onClick={() => navigate("/chat")}>
              {t("common.auxiliar.successPayment.startButton")}
              <FiMessageCircle />
            </PrimaryButton>
            <SecondaryButton onClick={() => navigate("/")}>
              {t("common.auxiliar.successPayment.goHomeButton")}
            </SecondaryButton>
          </SuccessCard>
        </SuccessContainer>
      </CaseDetailsContent>
    </CaseDetailsWrapper>
  );
};
